// _           __   ___   _____    __   _   _   __   _   _____
// | |        / /  /   | |  _  \  |  \ | | | | |  \ | | /  ___|
// | |  __   / /  / /| | | |_| |  |   \| | | | |   \| | | |
// | | /  | / /  / / | | |  _  /  | |\   | | | | |\   | | |  _
// | |/   |/ /  / /  | | | | \ \  | | \  | | | | | \  | | |_| |
// |___/|___/  /_/   |_| |_|  \_\ |_|  \_| |_| |_|  \_| \_____/

// THIS FILE IS AUTO GENERATED!!!!!!
// DO NO EDIT IT HERE.

// THE TEMPLATE IS AT: tasks/pkg/icon-template/src/index.tsx

import baseIcon, { defaultIconGroupProps } from '@bubble-ui/temp-icon-base';
var IconSocialMediaPath = 'M19 0H1v13l.005.176A3 3 0 0 0 4 16h3.207L10 19.644 12.792 16H16a3 3 0 0 0 3-3V0ZM3 2h14v11a1 1 0 0 1-1 1h-4.193l-1.808 2.356L8.193 14H4l-.117-.007A1 1 0 0 1 3 13V2Zm7 2.835-.098-.074a3.098 3.098 0 0 0-4.898 2.254c-.005.826.252 1.546.723 2.12l.087.093a1 1 0 0 0 .203.148l.073.034 3.193 3.287a1 1 0 0 0 1.424.01l3.4-3.4c.595-.582.922-1.4.892-2.242-.122-1.452-1.17-2.598-2.557-2.84a3.098 3.098 0 0 0-2.345.536L10 4.835Zm2.097 1.36a1.1 1.1 0 0 1 .907.99l-.006.118c-.026.202-.13.418-.297.582l-2.691 2.69-2.693-2.772-.1-.09-.079-.054-.015-.025A1.2 1.2 0 0 1 7 7.102c.039-.415.41-.821.903-.907a1.1 1.1 0 0 1 1.13.514l.059.11c.338.734 1.345.773 1.754.115l.062-.116a1.1 1.1 0 0 1 1.19-.623Z';
var IconSocialMedia = baseIcon('IconSocialMedia', {
  groupProps: defaultIconGroupProps,
  getPath: () => IconSocialMediaPath
});
export default IconSocialMedia;
//# sourceMappingURL=index.js.map